import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { BaseConnectionFormController } from '../../../../../../../../modules/connections/connection-form.controller';
import { IConnectionDetailsDTO } from '../../../../../../../../api/connections.dao';
import { FormVmItemConfigType } from '../../../../../../../../infrastructure/form-viewmodel-controller';
import { IErrorParsing } from '../../../../../../../../infrastructure/error-parsing';
import { alertServerError } from '../../../../../../../global/modal/alerts-host/alert-templates';
import { configList } from './panelist-link-connection.form-config';
import { PanelistLinkConnectionField as FieldKey } from './panelist-link-connection.form-config';

export class PanelistLinkConnectionFormVm extends BaseConnectionFormController {

    public static handleApiException(e: Error, title: string = 'Error'): void {
        if (e) alertServerError(title, IoC.Container.get(IErrorParsing).extractMessage(e));
    }

    public static get configList(): FormVmItemConfigType[] { return configList; }

    public static create(connection: IConnectionDetailsDTO): PanelistLinkConnectionFormVm {
        return new PanelistLinkConnectionFormVm(connection);
    }

    private constructor(connection: IConnectionDetailsDTO) {
        super(connection, PanelistLinkConnectionFormVm.configList);
        this.init(connection);
    }

    public toApiDTO(): IConnectionDetailsDTO {
        const data = super.toApiDTO();
        return data;
    };

    private async init(connection: IConnectionDetailsDTO): Promise<void> {
        if (connection) {
            this.setValue(FieldKey.ATTENDEE_ID, connection.attendeeId);
            this.setValue(FieldKey.CONNECTION_VERSION, connection.connectionVersion);
            this.setValue(FieldKey.PARENT_MEETING_CONNECTION_ID, connection.parentMeetingConnectionId);
            this.setValue(FieldKey.PARENT_JOIN_METHOD_ID, connection.parentJoinMethodId);
            this.setValue(FieldKey.JOIN_METHOD_ID, connection.joinMethodId);
        }
    }

    @mobx.action
    public setConnectionLink(value: string | null): void {
        this.setValue(FieldKey.CONNECTION_LINK, value);
    }
}